
import { Component} from '@angular/core';

// -----------------------------------------------------------------------------------------
@Component({
  selector: 'lib-generating-svg',
  templateUrl: './contract-generating.component.svg',
})
export class ContractGeneratingSvgComponent { }
